import { useEffect } from 'react'
import { fetchBarnList } from 'store/barnSlice'
import { useAppDispatch, useAppSelector } from 'store/hooks'

export const useGetBarnList = () => {
	const dispatch = useAppDispatch()
	const { barnList, loading } = useAppSelector(state => state.barnReducer)
	useEffect(() => {
		if (!barnList) {
			dispatch(fetchBarnList())
		}
	}, [barnList, dispatch])

	return { barnList, loading }
}
